const AJUDA = () => import(/* webpackChunkName: "ajuda" */ './main.vue');

export default [{
  name: 'ajuda',
  path: '/ajuda',
  component: AJUDA,
  meta: {
    requiresAuth: true,
    breadcrum: 'Ajuda',
    icon: 'question',
    can: 'list',
    on: 'ajuda',
    filho: true,
  },
}];
